<template>
  <div class="validator" :valid="valid" :invalid="!valid" v-if="!hide">
    <span v-for="e in errors" :key="e" class="errors__error">
      <img src="@/assets/error.svg"/>
        {{ v_chain[e].message }}
    </span>
  </div>
</template>

<script>
import {FieldValidatorProps} from "./FieldValidatorUtils";

export default {
  name: "validator",
  props: {
    required: FieldValidatorProps.Required,
    validate: FieldValidatorProps.Validate,
    fieldname: {
      type: String,
      required: true,
    },
    value: {
      required: false,
    },
    limit: {
      type: Boolean,
      required: false,
    },
    hide: {
      type: Boolean,
      required: false,
    },
  },
  data: function () {
    return {
      errors: [],
      v_chain: [],
      form: undefined,
    };
  },
  methods: {
    setForm() {
      this.form = this.$parent.$parent.$parent;
    },
    run() {
      this.v_chain = this.constructChain();
      this.errors = this.validateChain(this.v_chain);

      this.$emit("run-result", this.valid);

      return this.valid;
    },
    constructChain() {
      const chain = [];

      if (this.required) {
        chain.push({
          name: `${this.fieldname}_required`,
          message: "To polje je obvezno.",
          isInjected: true,
          validator: this.valueTruthyContext,
        });
      }

      if (Array.isArray(this.validate)) {
        chain.push(...this.validate);
      }
      return chain;
    },
    validateChain(chain) {
      const errors = [];

      for (let i = 0; i < chain.length; i++) {
        const v = chain[i];
        const valid = v.validator(this.value, this.form);

        if (!(typeof valid === "boolean") && !v.isInjected) {
          throw new Error(
            `Invalid validator at field ${this.fieldname}, validator ${v.name}. Every validator must return a boolean value.`
          );
        } else {
          if (!valid) {
            errors.push(i);
            if (this.limit) break;
          }
        }
      }

      return errors;
    },
    onFieldInput() {
      if (this.required) {
        const requiredChain = [
          {
            name: `${this.fieldname}_required`,
            message: "To polje je obvezno.",
            isInjected: true,
            validator: this.valueTruthyContext,
          },
        ];

        this.errors = this.validateChain(requiredChain);
      }
    },
    getValid() {
      return this.valid;
    },
    valueTruthyContext() {
      const type = typeof this.value;

      if (type === "string") {
        return this.value && this.value.length > 0;
      } else if (
        ["ui-checkbox", "ui-toggle"].includes(this.$parent.$options.name)
      ) {
        return this.value === true;
      } else {
        return this.value !== undefined;
      }
    },
  },
  mounted: function () {
    this.setForm();
    if (this.valueTruthyContext()) this.run();
  },
  computed: {
    valid() {
      return this.errors.length === 0;
    },
  },
};
</script>

<style scoped>
.validator {
  max-height: 0;
  opacity: 0;

  transition: all 0.3s ease-in-out;
}

.validator[invalid] {
  max-height: 100px;
  opacity: 1;
}

.validator .errors__error {
  display: flex;
  align-items: center;
  margin: 4px 0;

  font-family: "Open Sans";
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;

  color: #ed1c24;
}

.validator .errors__error img {
  display: inline-block;
  margin-right: 6px;
}
</style>
